import { useCallback } from 'react';
import { stateKeys } from '../model';

export const useOptionClick = ({ store, valueRef, onClose, onValueChange }) => {
  const handleSingleSelection = useCallback(
    (value) => {
      valueRef.current.onChange(value);
      onClose();
    },
    [valueRef, onClose]
  );

  const handleMultipleSelection = useCallback(
    (value) => {
      const currentValue = store.getState()[stateKeys.currentValue];
      let newVal;

      if (!currentValue) {
        newVal = [value];
      } else {
        newVal = currentValue.includes(value)
          ? currentValue.filter((item) => item !== value)
          : [...currentValue, value];
      }

      onValueChange(newVal);
    },
    [store, onValueChange]
  );

  const handleOptionClick = useCallback(
    (option) => {
      store.getState()[stateKeys.multiple]
        ? handleMultipleSelection(option.value)
        : handleSingleSelection(option.value);
    },
    [handleMultipleSelection, handleSingleSelection, store]
  );

  return handleOptionClick;
};
